export default __webpack_public_path__ + "static/media/aumento-produtividade.9b70bab1.svg";